<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import { ChevronDown } from 'lucide-vue-next';
    import { SelectIcon, SelectTrigger, type SelectTriggerProps, useForwardProps } from 'reka-ui';
    import { cn } from '@/lib/utils';

    const props = withDefaults(
        defineProps<
            SelectTriggerProps & { class?: HTMLAttributes['class']; size?: 'sm' | 'default' }
        >(),
        { size: 'default' },
    );

    const delegatedProps = reactiveOmit(props, 'class', 'size');
    const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <SelectTrigger
        data-slot="select-trigger"
        :data-size="size"
        v-bind="forwardedProps"
        :class="
            cn(
                `border-input data-[placeholder]:text-faded-foreground [&_svg:not([class*='text-'])]:text-foreground aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive disabled:bg-faded flex w-fit cursor-pointer items-center justify-between gap-2 rounded-md border bg-transparent px-2.5 py-2 text-xs whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none disabled:cursor-not-allowed data-[size=default]:h-7.5 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4`,
                props.class,
            )
        "
    >
        <slot />
        <SelectIcon as-child>
            <ChevronDown class="size-4 opacity-50" />
        </SelectIcon>
    </SelectTrigger>
</template>
